<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Zmiana placówki
  </div>

  <div  fxFlex="100">
    <app-dict-partners label="Partner" [control]="partnerControl" [multiple]="false" [required]="true"></app-dict-partners>
  </div>

  <div  fxFlex="100" *ngIf="enableFacility && partnerControl.value">
    <app-partner-facility-select label="Placówka" [control]="partnerFacilityControl" [multiple]="false" [required]="true"
                              [partnerIdString]="partnerControl.value"  [attr.key]="partnerControl.value">  ></app-partner-facility-select>
  </div>
  <div  fxFlex="100" *ngIf="!enableFacility && partnerControl.value">
    <app-partner-facility-select label="Placówka" [control]="partnerFacilityControl" [multiple]="false" [required]="true"
                                 [partnerIdString]="partnerControl.value"  [attr.key]="partnerControl.value">  ></app-partner-facility-select>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

